import { SectionHeader, Table, TableBody, TableCell, TableContainer, TableRow } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';
import type { AdminProcess } from './adminProcessDetailsTypes';
import { ServiceType } from '../../../../common/enums/serviceType';
import { translateKey } from '../../../translate';
import { FullName, ItemBold } from '../../elements/common';
import { NullableFormattedDatetime } from '../../elements/NullableFormattedDatetime';
import { StatusLabelManager } from '../../elements/StatusLabelManager';

interface IAdminProcessCoupledProcessesProps {
    adminProcess: AdminProcess;
    requestId?: string;
}

export function AdminProcessCoupledProcesses(props: IAdminProcessCoupledProcessesProps) {
    const navigate = useNavigate();
    if (
        props.adminProcess.service.serviceType === ServiceType.invitation ||
        !props.adminProcess.relatedProcesses ||
        props.adminProcess.relatedProcesses.length === 0
    ) {
        return null;
    }

    return (
        <>
            <SectionHeader title={translateKey('processDetails.coupledProcesses')} />
            {props.adminProcess.relatedProcesses && props.adminProcess.relatedProcesses.length > 0 && (
                <TableContainer>
                    <Table spacing="medium">
                        <TableBody>
                            {props.adminProcess.relatedProcesses.map((process) => (
                                <TableRow
                                    key={process.id}
                                    onClick={() => navigate(`/processes/${process.id}`)}
                                >
                                    <TableCell></TableCell>
                                    <TableCell>{process.service.code}</TableCell>
                                    <TableCell>
                                        <ItemBold>{process.processId}</ItemBold>
                                    </TableCell>
                                    <TableCell>
                                        <FullName {...process.patient.careProviderPractitioner} />
                                    </TableCell>
                                    <TableCell>
                                        <ItemBold>{getName(process)}</ItemBold>
                                    </TableCell>
                                    <TableCell>
                                        <NullableFormattedDatetime value={process.created_at} />
                                    </TableCell>
                                    <TableCell>
                                        <StatusLabelManager
                                            badge
                                            request={process}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </>
    );

    function getName(process: AdminProcess) {
        if (process.recipientPractitioner) {
            return <FullName {...process.recipientPractitioner} />;
        } else if (process.recipientOrganization) {
            return process.recipientOrganization.name;
        }

        return null;
    }
}
